import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
export class TS_Form extends ComponentSync {
    deriveStateFromProps(nextProps) {
        const state = this.state ? { ...this.state } : {};
        return state;
    }
    render() {
        return _jsx("div", {});
    }
}
//# sourceMappingURL=TS_Form.js.map